import easydropdown from 'easydropdown';

export class Visits {
  constructor () {
    this.visitsEl = document.querySelector('.js-visits');
    if (!this.visitsEl) return;

    this.visitDataEl = this.visitsEl.querySelectorAll('.js-visits-data');
    this.dateToggle = this.visitsEl.querySelector('.js-visits-date-toggle');
    this.hourBarEls = this.visitsEl.querySelectorAll('.js-visits-hourbar');
    this.hourBarWrapperEls = this.visitsEl.querySelectorAll('.js-visits-hourwrappers');

    if (!this.visitDataEl || !this.dateToggle || !this.hourBarEls) return;

    this.max = 3;
    this.date = new Date();
    this.currentDayIndex = this.date.getDay();
    this.currentHour = this.date.getHours();
    this.visitData = new Map();
    this.visitDataEl.forEach((el) => {
      const data = JSON.parse(el.innerHTML);
      this.visitData[data.day] = data.traffic;
    });

    this.dropdown = easydropdown(this.dateToggle, {
      callbacks: {
        onSelect: () => {
          if (this.dateToggle.options[this.dateToggle.selectedIndex].dataset.dayIndex) {
            this.setGraphToDay(this.dateToggle.options[this.dateToggle.selectedIndex].dataset.dayIndex);
          }
        }
      }
    });
    this.setGraphToDay(this.currentDayIndex);
    this.dateToggle.value = this.currentDayIndex;
  }

  setGraphToDay(idx) {
    const dayData = this.visitData[idx];

    this.hourBarEls.forEach((el, idx) => {
      const percentage = Math.floor(parseInt(dayData[idx]) / this.max * 100);
      el.style.height = `${percentage}%`;

      if (parseInt(el.dataset.hour) == this.currentHour) {
        el.classList.add('is-currenthour');
      } else {
        el.classList.remove('is-currenthour');
      }

      // Assign hover text designation
      if (percentage > (200/3)) {
        el.parentElement.setAttribute('data-density', 'high');
        el.parentElement.classList.add('is-hoverrable');
      } else if (percentage > (100/3)) {
        el.parentElement.setAttribute('data-density', 'medium');
        el.parentElement.classList.add('is-hoverrable');
      } else if (percentage == 0) {
        el.parentElement.setAttribute('data-density', 'low');
        el.parentElement.classList.remove('is-hoverrable');
      } else {
        el.parentElement.setAttribute('data-density', 'low');
        el.parentElement.classList.add('is-hoverrable');
      }
    });
  }

  static loadAndRun() {
    new Visits();
  }
}
